import { render, staticRenderFns } from "./FlightAvailabilitiesList.vue?vue&type=template&id=09cc804f&"
import script from "./FlightAvailabilitiesList.vue?vue&type=script&lang=js&"
export * from "./FlightAvailabilitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports